import React, { useEffect } from 'react'
import { AuthRoute, NotFound, Route, Switch, useHistory } from '@fs/zion-router'
import Subnav from '@fs/zion-tree-subnav-legacy'
import { GroupsProvider } from '@fs/zion-tree-groups'
import LabelProvider from './components/Following/LabelProvider'

const FollowingPage = React.lazy(() => import('./components/Following/FollowingPage'))
const MyContributionsPage = React.lazy(() => import('./components/MyContributions/MyContributionsPage'))

function App({ setIsStatsPage, setPageBanner }) {
  const history = useHistory()

  useEffect(() => {
    // TODO: Remove after confirming all links to /tree/list/* have been replaced with /tree/following
    // Since /tree/list/people is a binding_set (to hijack from TreeWeb) history.loaction.pathname will just be '/'
    if (window.location.pathname.includes('/tree/list')) {
      window.location.pathname = '/tree/following'
    }
  }, [history])

  useEffect(() => {
    if (history.location.pathname.includes('/tree/contributions')) {
      setPageBanner('contributions')
    } else if (history.location.pathname === '/') {
      setPageBanner('following')
    } else {
      setPageBanner('')
    }
  }, [history, setPageBanner])

  return (
    <Switch>
      {/* Binding set resolves to familysearch.org/tree/following */}
      <AuthRoute exact path="/">
        <LabelProvider>
          <GroupsProvider>
            <Subnav page="following" />
            <FollowingPage />
          </GroupsProvider>
        </LabelProvider>
      </AuthRoute>
      {/* Subjoined path resolves to familysearch.org/tree/contributions */}
      <AuthRoute exact path="/tree/contributions/:tabName?">
        <GroupsProvider>
          <Subnav page="contributions" />
          <MyContributionsPage setIsStatsPage={setIsStatsPage} />
        </GroupsProvider>
      </AuthRoute>
      <Route component={NotFound} />
    </Switch>
  )
}
export default App
